/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiKeyResponse } from '../../models/api-key-response';
import { CreateApiKeyRequest } from '../../models/create-api-key-request';

export interface CreateApiKey$Params {
  'Active-Tenant-Identifier': string;
      body: CreateApiKeyRequest
}

export function createApiKey(http: HttpClient, rootUrl: string, params: CreateApiKey$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiKeyResponse>> {
  const rb = new RequestBuilder(rootUrl, createApiKey.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiKeyResponse>;
    })
  );
}

createApiKey.PATH = '/api-keys';
